import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getGroups, getParticularPage, getNext, getPrevious, createGroups, updateGroups, handleSearch } from "./thunk";

const initialState = {
  groups: [],
  edit: false,
  group: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingGroups: false,
  loadingNext: false,
  showCreateModal: false,
};

export const groupsSlice = createSlice({
  name: "groups",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    groupsEditSuccess: (state, action) => {
      state.edit = true;
      state.group = state.groups.find((group) => group.id === action.payload);
    },
    clearAllGroups: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingGroups = false;
      state.group = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createGroups.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createGroups.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createGroups.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateGroups.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateGroups.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateGroups.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(getGroups.pending, getParticularPage.pending, getPrevious.pending, getNext.pending, handleSearch.pending),
      (state) => {
        state.loadingGroups = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getGroups.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingGroups = false;
        state.groups = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getGroups.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingGroups = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, groupsEditSuccess, clearAllGroups } = groupsSlice.actions;

export default groupsSlice.reducer;
